import { Link, Text } from '@chakra-ui/react';
import React from 'react';

import PageContainer from '../../components/pageContainer/PageContainer';

function Contact() {
  return (
    <PageContainer>
      <Text color='#377DFF' fontSize='2xl' fontWeight={500}>Contact Us</Text>
      <Text>
        If you have any questions or inquiries, you can email us at&nbsp;
        <Link href='mailto:contact@safecert.cloud' isExternal color='#007bff'>
          contact@safecert.cloud
        </Link>
      </Text>
    </PageContainer>
  );
}

export default Contact;
